import { useCallback } from 'react';

import { useTrackPlayedVideo } from '@air/analytics';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { usePlayerTransportController } from '../components/PlayerTransportProvider';

export const usePlayerPlay = () => {
  const { transportController } = usePlayerTransportController();
  const id = usePlayerStore((state) => state.id);
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { trackPlayedVideo } = useTrackPlayedVideo();

  const onPlayerPlay = useCallback(() => {
    if (transportController) {
      transportController.play();
      return;
    }

    if (videoElement) {
      videoElement.play();
      trackPlayedVideo({ id });
    }
  }, [transportController, videoElement, id, trackPlayedVideo]);

  return { onPlayerPlay };
};
